import React, {useState} from 'react';

import RichTextEditor from './RichTextEditor';
import {commentSchema} from './CommentEditor';
import {updateComment} from '../api/api';

const CommentEdit = ({
  id, currText, onFinish, isReply,
}) => {
  const [text, setText] = useState(currText);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onEditorChange = (markdown) => {
    setText(markdown);
    setError(null);
  };

  const handleSubmit = async () => {
    try {
      if (submitting) return;
      setSubmitting(true);
      const comment = {text};
      if (!isReply) await commentSchema.validate(comment);
      const status = await updateComment(id, comment);
      if (status === 'success') onFinish(comment.text);
    } catch (err) {
      setError(err);
    }

    setSubmitting(false);
  };

  return (
    <>
      <RichTextEditor
        initialMarkdown={currText}
        onChange={onEditorChange}
        onCancel={() => onFinish(currText)}
        onSubmit={handleSubmit}
        showToolbar
      />
      {error && (
        <div className="text-right text-red-600 text-sm pt-2 pb-4 px-4">
          {error.message}
        </div>
      )}
    </>
  );
};

export default CommentEdit;
